"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPath = void 0;
/**
 * Ustawia wartość obiektu na wybranej ścieżce
 *
 * @export
 * @param {object} obj
 * @param {*} value
 * @param {(string | string[])} path
 */
function setPath(obj, value, path) {
    if (!Array.isArray(path)) {
        path = path.split('.');
    }
    let index;
    for (index = 0; index < path.length - 1; index++) {
        const currentPath = path[index];
        if (!obj[currentPath]) {
            if (typeof obj !== 'object') {
                throw new Error('Nie można utworzyć ścieżki');
            }
            obj[currentPath] = {};
        }
        obj = obj[currentPath];
    }
    obj[path[index]] = value;
}
exports.setPath = setPath;
//# sourceMappingURL=setPath.js.map